import classes from './Expansions.module.scss';
import { useState } from 'react';

import ArrowDownIcon from 'assets/icons/arrow-down.svg';
import ArrowUpIcon from 'assets/icons/arrow-up-icon.svg';

const Expansions = ({ data }) => {
	const [toggleExpansions, setToggleExpansions] = useState(() => {
		const tempState = [];
		data.map((group, index) => {
			tempState.push([]);
			group.contents.map(() => {
				tempState[index].push(false);
			});
		});
		return tempState;
	});

	const setToggleHanlder = (groupIndex, itemIndex) => {
		let temp = [...toggleExpansions];
		temp[groupIndex][itemIndex] = !temp[groupIndex][itemIndex];
		setToggleExpansions(temp);
	};
	return (
		<div className={classes['expansion-container']}>
			{data.map((group, groupIndex) => (
				<div key={group.id} className={classes['expansion-group']}>
					<h1 className={classes['expansion-group-header']}>{group.name}</h1>
					{group.contents.map((item, itemIndex) => (
						<div key={item.id} className={classes['expansion-group-item']}>
							<button
								className={classes['expansion-group-item-header']}
								onClick={() => setToggleHanlder(groupIndex, itemIndex)}>
								{item.question}
								{toggleExpansions[groupIndex][itemIndex] ? <ArrowUpIcon /> : <ArrowDownIcon />}
							</button>
							{toggleExpansions[groupIndex][itemIndex] && (
								<div className={classes['expansion-group-item-content']}>{item.description}</div>
							)}
						</div>
					))}
				</div>
			))}
		</div>
	);
};

export default Expansions;
